<template>
    <div>
        <h2 v-if="role.custom" v-html="__('roles.role-permission.edit', {roleName: getStoreRole(role.name)})"/>
        <h2 v-else v-html="__('roles.role-permission.view', {roleName: getStoreRole(role.name)})"/>
        <p v-show="role.custom">
            {{ __('roles.role-permission.choose') }}
        </p>
        <div class="checkbox-list">
            <div class="row no-gutters">
                <div class="col-lg-6 px-3 py-3 bg-hover-light-primary" v-for="permission in allPermissions">
                    <div class="row no-gutters">
                        <div class="col-6 d-flex align-items-center text-break">
                            {{ __('store-permissions.' + permission) }}
                        </div>
                        <div class="col-6">
                            <label class="checkbox checkbox-lg mb-0">
                                <input type="checkbox"
                                       :name="permission"
                                       :checked="givenPermissions.includes(permission)"
                                       :disabled="isDefaultRole"/>
                                <span/>
                                <p class="text-break">{{ permission }}</p>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import getStoreRole from '@mixins/store_roles'
import Navigation from "@pages/Stores/Edit/Nav/Navigation.vue";

export default {
    layout: Navigation,

    mixins: [getStoreRole],

    props: {
        storeUuid: String,
        allPermissions: Object,
        givenPermissions: Array,
        role: Object,
        create: Boolean,
    },

    computed: {
        isDefaultRole() {
            return this.role.custom === 0
        },
    },
}
</script>
